import { DateRangeInput, type DateRangeValue } from "../DateRangeInput";

interface DateRangeColumnFilterFieldProps {
  value: DateRangeValue;
  onChange: (value: DateRangeValue) => void;
}

export function DateRangeColumnFilterField({
  value,
  onChange,
}: DateRangeColumnFilterFieldProps) {
  return (
    <div className="pt-3 pb-3.5">
      <DateRangeInput value={value} onChange={onChange} />
    </div>
  );
}
